(function () {

    function createCredit() {

        const holder = document.querySelector(".ms-credit-holder");

        if (!holder) return;

        holder.innerHTML =
            '<a class="ms-credit" href="https://makesyncplus.com" target="_blank" style="font-size:11px;opacity:.65;text-decoration:none;color:inherit;">Developed by Makesync Plus</a>';

    }

    createCredit();

    setInterval(createCredit, 3000);

})();